import { createLucideIcon } from "lucide-react";

export const Ai = createLucideIcon(
    "Ai",
    [
        [
            "path",
            {
                d: "M13.0013 2.1668V4.3334",
                key: "16l5rb",
            },
        ],
        [
            "path",
            {
                d: "M13.0013 21.6667V23.8334",
                key: "1hzyat",
            },
        ],
        [
            "path",
            {
                d: "M16.793 9.75V16.25",
                key: "19xsxi",
            },
        ],
        [
            "path",
            {
                d: "M17.3346 2.1668V4.3334",
                key: "1gz6fy",
            },
        ],
        [
            "path",
            {
                d: "M17.3346 21.6667V23.8334",
                key: "1jciho",
            },
        ],
        [
            "path",
            {
                d: "M23.8346 13.0001H21.668",
                key: "csfkx",
            },
        ],
        [
            "path",
            {
                d: "M23.8346 17.3334H21.668",
                key: "g3wvvn",
            },
        ],
        [
            "path",
            {
                d: "M23.8346 8.6668H21.668",
                key: "1l8jdh",
            },
        ],
        [
            "path",
            {
                d: "M4.33203 12.9999C4.33203 8.91441 4.33203 6.87166 5.60124 5.60246C6.87044 4.33325 8.91319 4.33325 12.9987 4.33325C17.0842 4.33325 19.127 4.33325 20.3962 5.60246C21.6654 6.87166 21.6654 8.91441 21.6654 12.9999C21.6654 17.0854 21.6654 19.1282 20.3962 20.3974C19.127 21.6666 17.0842 21.6666 12.9987 21.6666C8.91319 21.6666 6.87044 21.6666 5.60124 20.3974C4.33203 19.1282 4.33203 17.0854 4.33203 12.9999Z",
                key: "1omogm",
            },
        ],
        [
            "path",
            {
                d: "M4.3346 13.0001H2.168",
                key: "43gtjd",
            },
        ],
        [
            "path",
            {
                d: "M4.3346 17.3334H2.168",
                key: "kajah7",
            },
        ],
        [
            "path",
            {
                d: "M4.3346 8.6668H2.168",
                key: "n8r6zg",
            },
        ],
        [
            "path",
            {
                d: "M8.125 16.25L10.1204 10.2639C10.2227 9.957 10.5099 9.75 10.8333 9.75C11.1568 9.75 11.444 9.957 11.5463 10.2639L13.5417 16.25",
                key: "8nlp2p",
            },
        ],
        [
            "path",
            {
                d: "M8.668 2.1668V4.3334",
                key: "co1ebr",
            },
        ],
        [
            "path",
            {
                d: "M8.668 21.6667V23.8334",
                key: "1hy3cs",
            },
        ],
        [
            "path",
            {
                d: "M9.2083 14.0833H12.4583",
                key: "10opga",
            },
        ],
    ],
);
